<template>
    <div class="ppv2-w-full ppv2-flex ppv2-flex-col" style="gap: 14px">
        <div class="ppv2-flex ppv2-items-center" style="gap: 14px; padding-top: 10px">
            <span
                class="poppinsRegular ppv2-uppercase"
                :style="{ fontSize: normalizeFontSize(12), letterSpacing: '0.03em', color: '#9aa4b2' }"
            >
                {{ $t('forms.presentation.title') }}
            </span>
            <span style="flex: 1; height: 1px; background: #e2e6ec"></span>
        </div>

        <div class="ppv2-bg-white dark:ppv2-bg-dark" style="border: 1px solid #e2e6ec; border-radius: 12px; padding: 18px">
            <div class="poppinsSemiBold ppv2-text-black ppv2-text-md ppv2-mb-3">
                {{ $t('forms.presentation.image') }}
            </div>
            <CustomInputUpload
                :value="image"
                enable-cropper
                accept="image/*"
                :class-container-add="'!ppv2-w-full'"
                :specific-taille="$t('forms.presentation.imageHint')"
                @input="$emit('update:image', $event)"
            />
        </div>

        <div class="ppv2-bg-white dark:ppv2-bg-dark" style="border: 1px solid #e2e6ec; border-radius: 12px; padding: 18px">
            <div class="poppinsSemiBold ppv2-text-black ppv2-text-md ppv2-mb-3">
                {{ $t('forms.presentation.description') }}
            </div>
            <div class="poppinsRegular" style="font-size: 12.5px; color: #6b7480; margin-bottom: 12px">
                {{ $t('forms.presentation.descriptionSubtitle') }}
            </div>
            <BaseTextarea
                :value="description"
                :rows="4"
                :placeholder="$t('forms.presentation.descriptionPlaceholder')"
                :class-container-add="'!ppv2-mb-0'"
                @input="$emit('update:description', $event)"
            />
        </div>
    </div>
</template>

<script>
import normalizeFontSize from '../../../../utils/normalizeFontSize'
import BaseTextarea from '../../../Shared/BaseTextarea.vue'
import CustomInputUpload from '../../../Inputs/CustomInputUpload.vue'

export default {
    name: 'FormPresentation',
    components: { BaseTextarea, CustomInputUpload },
    props: {
        description: {
            type: String,
            default: '',
        },
        image: {
            type: [String, File, null],
            default: null,
        },
    },
    methods: {
        normalizeFontSize,
    },
}
</script>
